module.exports = __webpack_public_path__ + "static/media/lunch_icon.08295584.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lunch_icon.svg
// module id = 53
// module chunks = 0